import { FileConfig } from "../Constants";
import { RcFile } from "antd/lib/upload";

/**
 * Validates given file properties with a provided configuration of accepted file types
 * and maximum file size, returns custom error message based on the result
 */

export const validateFile = (file: RcFile, fileConfig: FileConfig): string => {
  if (
    !fileConfig.acceptableFileExtensions.some((extension: string) =>
      file?.name.toLowerCase().endsWith(extension)
    )
  ) {
    return fileConfig.errorMessages.invalidFileExtension;
  } else if (file?.size > fileConfig.maximumFileSize) {
    return fileConfig.errorMessages.invalidFileSize;
  }
  return "";
};
